import { kea } from "kea";

import api from '../utils/api';


export const userlogic = kea({
	actions: {
		create: (user) => ({ user }),
		fetchAll: true,
		update: (user) => ({ user }),
		remove: (user) => ({ user }),
		updateGroup: (user) => ({ user }),
		sendPasswordEmail: (user) => ({ user }),

		setAll: (users) => ({ users }),
		setOne: (user) => ({ user }),
		addOne: (user) => ({ user }),
		removeOne: (user) => ({ user }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		users: [null, {
			setAll: (_, { users }) => users,
			setOne: (state, { user }) => state.map((s) => s._id === user._id ? user : s),
			addOne: (state, { user }) => [...state, user],
			removeOne: (state, { user }) => state.filter((s) => user._id !== s._id),
		}],
		loading: [false, {
			create: () => true,
			fetchAll: () => true,
			update: () => true,
			remove: () => true,
			updateGroup: () => true,
			sendPasswordEmail: () => true,

			setAll: () => false,
			setOne: () => false,
			addOne: () => false,
			removeOne: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			setAll: () => null,
			setOne: () => null,
			addOne: () => null,
			removeOne: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		create: async ({ user }, breakpoint) => {
			await breakpoint(300);
			let url = '/user';
			let res;
			try {
				res = await api({ url, method: 'post', body: user });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.addOne(json.payload);
				actions.setSuccess('User Created.');
			} else actions.setError(json.error);
		},
		fetchAll: async (_, breakpoint) => {
			await breakpoint(300)
			let url = '/user';
			let res;
			try {
				res = await api({ url });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			breakpoint();
			const json = await res.json();
			if (res.ok) actions.setAll(json.payload);
			else actions.setError(json.error);
		},
		update: async ({ user }, breakpoint) => {
			await breakpoint(300);
			let url = `/user/${user._id}`;
			let res;
			try {
				res = await api({ url, method: 'put', body: user });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload);
				actions.setSuccess('User Updated.');
			} else actions.setError(json.error);
		},
		remove: async ({ user }, breakpoint) => {
			await breakpoint(300);
			let url = `/user/${user._id}`;
			let res;
			try {
				res = await api({ url, method: 'delete' });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.removeOne(json.payload);
				actions.setSuccess('User Disabled.');
			} else actions.setError(json.error);
		},
		updateGroup: async ({ user }, breakpoint) => {
			await breakpoint(300);
			let url = `/user/${user._id}/group`;
			let res;
			try {
				res = await api({ url, method: 'put', body: user });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload);
				actions.setSuccess('User Updated.');
			} else actions.setError(json.error);
		},
		sendPasswordEmail: async ({ user }, breakpoint) => {
			await breakpoint(300);
			let url = `/user/${user._id}/password_reset_email`;
			let res;
			try {
				res = await api({ url, method: 'post', body: user });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setSuccess('Password reset email sent.');
			} else actions.setError(json.error);
		}
	})
});

export default userlogic;